import {Table} from 'react-bootstrap-v5'
import {Link} from 'react-router-dom'
import {CardHeader} from '../../../../../modules/components'
import parseMoney from '../../../../../modules/utils/parseMoney'
import {ClinicInvoiceConsultModel} from '../models'

interface Props {
    invoiceConsults: ClinicInvoiceConsultModel[]
    isExport?: boolean
}

export default function ClinicConsultInvoiceSubpage({invoiceConsults, isExport = false}: Props) {
    return (
        <div className='card'>
            <CardHeader title='Serviços realizados' goBack={!isExport} />
            <div className='card-body p-5'>
                <Table
                    responsive
                    bordered
                    className='table table-hover table-row-dashed table-col-dashed align-middle table-rounded'
                    width='100%'
                >
                    <thead>
                        <tr className='fw-bolder text-muted bg-light'>
                            <th className='text-center'>Cód.</th>
                            <th className='text-center'>Data/Hora Consulta</th>
                            <th>Paciente</th>
                            <th className='text-center'>Vlr. Estabelecimento</th>
                            <th>Profissional</th>
                            <th className='text-center'>Vlr. Profissional</th>
                            {!isExport && <th className='text-center'>Ações</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {invoiceConsults.length > 0 ? (
                            invoiceConsults.map((consult) => (
                                <tr key={consult.id}>
                                    <td className='text-center'>{consult.id}</td>
                                    <td className='text-center'>{consult.date_hour}</td>
                                    <td className='text-nowrap'>{consult.nm_patient}</td>
                                    <td className='text-center text-nowrap'>
                                        <span className='fw-bolder'>
                                            {parseMoney(consult.vn_clinic)}
                                        </span>
                                    </td>
                                    <td className='text-nowrap'>{consult.nm_doctor}</td>
                                    <td className='text-center text-nowrap'>
                                        <span className='fw-bolder'>
                                            {parseMoney(consult.vn_doctor)}
                                        </span>
                                    </td>
                                    {!isExport && (
                                        <td className='text-center'>
                                            <Link
                                                to={`/principal/consultas/${consult.id}`}
                                                className='btn btn-icon btn-light-primary btn-sm'
                                            >
                                                <i className='fa fa-eye' />
                                            </Link>
                                        </td>
                                    )}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td className='text-center' colSpan={6}>
                                    Nenhum consulta com registro de informações
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
        </div>
    )
}
